import {
    EuiButtonIcon,
    EuiDescriptionList,
    EuiDescriptionListDescription,
    EuiDescriptionListTitle,
    EuiFlexGroup,
    EuiFlexItem,
} from "@elastic/eui";
import React from "react";

function OrderColumn({ title, id, onCreate, required, children }) {
    return (
        <EuiFlexItem
            className="create-order__header-column"
            id={id}
        >
            <EuiDescriptionList>
                <EuiDescriptionListTitle className="create-order__title">
                    <EuiFlexGroup justifyContent="spaceBetween">
                        <EuiFlexItem
                            className={required ? "create-order__title--required" : ""}
                            grow={false}
                        >
                            {title}
                        </EuiFlexItem>
                        <EuiFlexItem grow={false}>
                            {onCreate && (
                                <EuiButtonIcon
                                    iconType="plus"
                                    onClick={onCreate}
                                    aria-label={`Create ${title}`}
                                    size="m"
                                />
                            )}
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </EuiDescriptionListTitle>
                <EuiDescriptionListDescription>{children}</EuiDescriptionListDescription>
            </EuiDescriptionList>
        </EuiFlexItem>
    );
}

export default OrderColumn;
